<h1 mat-dialog-title>{{ 'labels.text.' + title | translate }}</h1>
<mat-dialog-content>{{ 'labels.text.Warning message' | translate }}</mat-dialog-content>
<mat-dialog-actions>
  <button mat-raised-button color="primary" mat-dialog-close>{{ 'labels.buttons.' + buttonText | translate }}</button>
</mat-dialog-actions>
